// src/components/Accounts/Salary/index.jsx
import React from "react";
import FormsPage from "./FormsPage";
import { Box, Typography, Stack } from "@mui/material";
import BackButton from "../../../components/BackButton/BackButton";
import AgentAccountDetails from "./salaryDel";
import AgentsEditor from "./EditAgents";

const Salary = () => {
  return (
    <Box>
      <Box sx={{ p: 2 }}>
          {/* Top bar: Back + Title */}
          <Stack
            // direction={{ xs: "row" }}
            alignItems={{ xs: "flex-start" }}
            // justifyContent="space-between"
            spacing={5}

          >
            <BackButton  />
          <Typography variant="h3" sx={{marginY:3}}>Salary</Typography>
        </Stack>
      </Box>

      <AgentAccountDetails/>

      {/* <FormsPage /> */}
    </Box>
  );
};

export default Salary;
